import './style.scss';
import React, { createRef, useEffect } from 'react';

export interface UQTableSortSearchProps {
  search: string;
  children?: React.ReactNode;
  className?: string;
}

const UQTableSortSearch: React.FC<UQTableSortSearchProps> = ({ search, children, className }) => {
  const tableRef = createRef<HTMLTableElement>();
  const inputRef = createRef<HTMLInputElement>();

  useEffect(() => {
    const headers = tableRef.current!.querySelectorAll('thead th');

    headers.forEach((header, index) => {
      header.addEventListener('click', () => {
        const tbody = tableRef.current!.querySelector('tbody');
        const rows = Array.from(tbody!.rows);

        const headerElement = header as HTMLElement;
        const sortDirection = headerElement.dataset.sort === 'asc' ? 'desc' : 'asc';
        headerElement.dataset.sort = sortDirection;

        headers.forEach((h) => {
          const otherHeader = h as HTMLElement;
          if (otherHeader !== headerElement) delete otherHeader.dataset.sort;
        });

        rows.sort((a, b) => {
          const cellA = (a as HTMLTableRowElement).cells[index].innerText.trim();
          const cellB = (b as HTMLTableRowElement).cells[index].innerText.trim();
          const cellANumStart = cellA.replace(/\s*([0-9]+).*/, '$1');
          const cellBNumStart = cellB.replace(/\s*([0-9]+).*/, '$1');

          if (!isNaN(Number(cellA)) && !isNaN(Number(cellB))) {
            return sortDirection === 'asc'
              ? Number(cellA) - Number(cellB)
              : Number(cellB) - Number(cellA);
          } else if (!isNaN(Number(cellANumStart)) && !isNaN(Number(cellBNumStart))) {
            return sortDirection === 'asc'
              ? Number(cellANumStart) - Number(cellBNumStart)
              : Number(cellBNumStart) - Number(cellANumStart);
          } else {
            return sortDirection === 'asc'
              ? cellA.localeCompare(cellB)
              : cellB.localeCompare(cellA);
          }
        });

        rows.forEach((row) => tbody!.appendChild(row));
      });
    });

    inputRef.current!.addEventListener('input', () => {
      const query = inputRef.current!.value.toLowerCase();
      const rows = tableRef.current!.querySelectorAll('tbody tr');

      rows.forEach((row) => {
        const cells = Array.from((row as HTMLTableRowElement).cells);
        const match = cells.some((cell) =>
          cell.textContent?.toLowerCase().includes(query)
        );
        (row as HTMLTableRowElement).style.display = match ? '' : 'none';
      });
    });
  }, []);

  return (
    <>
      <input
        className="form-control mb-1"
        placeholder={search || 'Search'}
        ref={inputRef}
      />
      <table className={`uq-table ${className || ''}`} ref={tableRef}>
        {children}
      </table>
    </>
  );
};

export default UQTableSortSearch;
